import React, { useEffect, useState, useMemo } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
  useHistory,
} from "react-router-dom";
import MainPage from "./Pages/MainPage";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import "./i18n";
import Login from "./Pages/Login";
import BarberMainPage from "./Pages/BarberMainPage";
import AdminPage from "./Pages/AdminPage";
import LandingPage from "./Pages/LandingPage";
import AdminMainPage from "./Pages/AdminComps/AdminMainPage";
import ExplainVideo from "./Pages/ExplainVideo";
import BarberSubs from "./Pages/BarberSubs";

//for local
//export const MyDomain = "http://10.0.0.7/";
//export const MyDomain = "http://172.20.10.11/";
export const MyDomain =
  "https://neholtorem.happymushroom-066fb8ce.westeurope.azurecontainerapps.io/";

//for cloud
const App = () => {
  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const lang = JSON.parse(localStorage.getItem("lang")) ?? JSON.stringify("he");
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const history = useHistory();

  useEffect(() => {
    changeLanguage(lang);
    const normalizedPath = window.location.pathname.toLowerCase();
    if (window.location.pathname !== normalizedPath) {
      history.replace(normalizedPath); // Redirect to lowercase URL
    }
  }, [history]);

  useEffect(() => {
    //handleClearSpecificItem();
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const handleClearSpecificItem = () => {
  //   const keyToRemove = "wishList"; // Replace 'yourKey' with the key of the item you want to remove
  //   localStorage.removeItem(keyToRemove);
  //   console.log(`${keyToRemove} removed from localStorage`);
  // };

  return (
    <div
      style={{
        justifyContent: "center",
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      <Switch>
        <Route exact path="/" component={MainPage} />
        <Route
          exact
          path="/barber-main-page/:BarberPhoneNumber"
          component={BarberMainPage}
        />
        <Route exact path="/login" component={Login} />
        <Route exact path="/admin-page" component={AdminPage} />
        <Route exact path="/landing-page" component={LandingPage} />
        <Route exact path="/admin-main-page" component={AdminMainPage} />
        <Route exact path="/explain-video" component={ExplainVideo} />
        <Route exact path="/barber-subs" component={BarberSubs} />
      </Switch>
    </div>
  );
};

export default App;
